import React from "react";

import { IDiscount } from "../../../../types/discount.type";
import ModalBottomButtons from "../buttons/ModakBottomButtons/ModalBottomButtons";
import ViewInput from "../inputs/ViewInput/ViewInput";
import styles from "./styles.module.scss";
interface Props {
  discount: IDiscount;
  onClose: () => void;
  onPressEdit: () => void;
}

const ViewDiscountForm: React.FC<Props> = (props) => {
  return (
    <div>
      <div className={styles.form}>
        {props.discount.products.length === 0 ? (
          <ViewInput title="Товари" value="Товари з цим дісконтом відсутні" />
        ) : (
          props.discount.products.map((item, index) => (
            <ViewInput
              key={item.id}
              title={index === 0 ? "Товари" : ""}
              value={`${item.name}/${item.price}`}
            />
          ))
        )}
      </div>

      <ModalBottomButtons
        backTitle="Назад"
        onPressBack={props.onClose}
        applyTitle="Редагувати"
        onPressApply={props.onPressEdit}
      />
    </div>
  );
};

export default ViewDiscountForm;
